import React from "react";
import HeaderVideo from "../../medias/LandingPage-HeaderVideo.mp4";
import HeroBottomSection from "../../medias/heroButtomImg.png";

const Banner = () => {
  return (
    <div className="relative pt-5">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[1100px] sm:h-[1200px] md:h-[800px] lg:h-[900px] bg-gradient-to-b from-[#3B79B3] to-[#19344D]" />

      <div className="relative overflow-hidden">
        <div className="mx-auto flex flex-col md:max-w-6xl md:flex-row md:items-center md:justify-between px-6 sm:px-10 lg:px-10 pt-10 md:pt-3 lg:pt-3">
        <div className="w-full md:w-1/2">
          <p className="text-white font-bold max-w-xl text-[24px] leading-[36px] md:text-[26px] md:leading-[36px] lg:text-[26px] lg:leading-[36px] mb-6">
            <span className="block mb-3 text-[36px] leading-[46px] md:text-[44px] md:leading-[56px] lg:text-[52px] lg:leading-[64px]">Amazon Custom & Handmade order data and images—on your packing slips.</span>
            CustomSync sends order customization <span className="text-[#F29E13]">text</span> and <span className="text-[#F29E13]">images</span> from Amazon directly to ShipStation or Veeqo.
          </p>

          <a href="https://customsync.app/login?signup=true" className="inline-block">
            <div className="cursor-pointer bg-[#F29E13] px-6 py-3 rounded-lg font-bold text-white orange-button w-fit">
              Start Your Free Trial
            </div>
          </a>
        </div>
        <div className="w-full md:w-1/2 flex justify-center mt-10 md:mt-0">
          <div className="aspect-[4/3] w-full max-w-[400px] md:max-w-[500px] overflow-hidden rounded-lg shadow-lg">
            <video
              className="h-full w-full object-cover object-center"
              src={HeaderVideo}
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            />
          </div>
        </div>
      </div>
        <img
          className="relative mx-auto w-full max-w-5xl px-6 lg:px-0"
          src={HeroBottomSection}
          alt="CustomSync features preview"
        />
      </div>
    </div>
  );
};

export default Banner;
